import React, { useState, useEffect } from 'react';

const font = "'Inter', -apple-system, BlinkMacSystemFont, sans-serif";
const C = {
  blue: '#1a56db', bg: '#f0f2f5', white: '#ffffff',
  gray2: '#f3f4f6', gray3: '#e5e7eb', gray5: '#6b7280',
  gray6: '#374151', gray7: '#111827', green: '#16a34a',
  greenBg: '#dcfce7', red: '#dc2626', redBg: '#fee2e2',
};

export default function PushSendPage() {
  const [title,   setTitle]   = useState('');
  const [body,    setBody]    = useState('');
  const [url,     setUrl]     = useState('/');
  const [subs,    setSubs]    = useState([]);
  const [result,  setResult]  = useState(null);
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState(null);

  useEffect(() => {
    fetch('/api/push/subscriptions')
      .then(r => r.json())
      .then(setSubs)
      .catch(() => {});
  }, []);

  async function send() {
    if (!title.trim()) return setError('Title is required');
    setLoading(true); setError(null); setResult(null);
    try {
      const r = await fetch('/api/push/send', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ title: title.trim(), body: body.trim(), url: url.trim() || '/' }),
      });
      const d = await r.json();
      if (d.error) throw new Error(d.error);
      setResult(d);
      // Refresh subscription list
      fetch('/api/push/subscriptions').then(r => r.json()).then(setSubs).catch(() => {});
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  const card = { background: C.white, borderRadius: 16, padding: '28px 28px', boxShadow: '0 4px 24px rgba(0,0,0,0.07)', maxWidth: 520, width: '100%' };
  const label = { display: 'block', fontSize: 11, fontWeight: 600, color: C.gray5, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 6, marginTop: 16 };
  const input = { width: '100%', padding: '10px 12px', fontSize: 14, border: '1px solid ' + C.gray3, borderRadius: 8, fontFamily: font, color: C.gray7, background: C.white, boxSizing: 'border-box' };

  return (
    <div style={{ minHeight: '100vh', background: C.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px 16px', fontFamily: font }}>
      <div style={card}>
        <div style={{ marginBottom: 20 }}>
          <div style={{ fontSize: 11, fontWeight: 600, color: C.blue, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 8 }}>MessageBeacon</div>
          <h1 style={{ fontSize: 22, fontWeight: 700, color: C.gray7, margin: '0 0 6px' }}>Send Push Notification</h1>
          <div style={{ fontSize: 13, color: C.gray5 }}>
            {subs.length === 0
              ? 'No subscribed devices yet.'
              : `${subs.length} subscribed device${subs.length !== 1 ? 's' : ''}`}
          </div>
        </div>

        {/* Subscriber list */}
        {subs.length > 0 && (
          <div style={{ background: C.gray2, borderRadius: 8, padding: '10px 12px', marginBottom: 4 }}>
            {subs.map(s => (
              <div key={s.id} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, color: C.gray5, padding: '2px 0' }}>
                <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1, marginRight: 8 }}>
                  {s.user_agent?.split(' ').slice(-2).join(' ') || 'Unknown device'}
                </span>
                <span style={{ flexShrink: 0 }}>{new Date(s.created_at).toLocaleDateString('en-GB')}</span>
              </div>
            ))}
          </div>
        )}

        <label style={label}>Title *</label>
        <input value={title} onChange={e => setTitle(e.target.value)} placeholder="e.g. New message for your beacon" style={input} />

        <label style={label}>Body</label>
        <textarea value={body} onChange={e => setBody(e.target.value)} placeholder="Optional message body..." rows={3}
          style={{ ...input, resize: 'vertical' }} />

        <label style={label}>URL to open on tap</label>
        <input value={url} onChange={e => setUrl(e.target.value)} placeholder="/" style={input} />

        {error && (
          <div style={{ background: C.redBg, border: '1px solid #fecaca', borderRadius: 8, padding: '10px 12px', marginTop: 14, fontSize: 13, color: C.red }}>
            {error}
          </div>
        )}

        {result && (
          <div style={{ background: C.greenBg, border: '1px solid #bbf7d0', borderRadius: 8, padding: '10px 12px', marginTop: 14, fontSize: 13, color: C.green }}>
            ✅ Sent to {result.sent} device{result.sent !== 1 ? 's' : ''}
            {result.failed > 0 && ` · ${result.failed} failed`}
            {result.staleRemoved > 0 && ` · ${result.staleRemoved} expired removed`}
          </div>
        )}

        <button
          onClick={send}
          disabled={loading || subs.length === 0}
          style={{
            width: '100%', marginTop: 20, padding: '12px 0', fontSize: 14, fontWeight: 600,
            background: (loading || subs.length === 0) ? C.gray3 : C.blue,
            color: (loading || subs.length === 0) ? C.gray5 : '#fff',
            border: 'none', borderRadius: 10,
            cursor: (loading || subs.length === 0) ? 'not-allowed' : 'pointer',
            fontFamily: font,
          }}
        >
          {loading ? 'Sending…' : `Send to ${subs.length} device${subs.length !== 1 ? 's' : ''}`}
        </button>

        <div style={{ marginTop: 16, textAlign: 'center' }}>
          <a href="/push" style={{ fontSize: 12, color: C.blue }}>← Subscribe page</a>
        </div>
      </div>
    </div>
  );
}
